import usePopup, {ServerErrorPopupProps} from '@/root/hooks/usePopup';

import Popup from '@/shared/components/Popup/Layout';
import {DicaronCommonErrorCode} from '@/shared/constants/dicaronServerErrorCode';
import {TIARA_ACTION} from '@/shared/constants/tiara';
import useHistoryBackAOS from '@/shared/hooks/useHistoryBackAOS';
import {nl2br} from '@/shared/utils/nl2br';

type ErrorInfo = {
  [key in DicaronCommonErrorCode]: {title: string; content: JSX.Element[] | string};
};

const ERROR_INFO: ErrorInfo = {
  [DicaronCommonErrorCode.BAD_REQUEST]: {
    title: '서비스 오류 안내',
    content: nl2br(
      '예상하지 못한 오류가 발생하였습니다.\n서버의 일시적인 장애이거나 네트워크 문제일 수 있습니다. 잠시 후 다시 시도해 주세요.'
    )
  },
  [DicaronCommonErrorCode.INVALID_ACCOUNT_STATUS]: {
    title: '서비스 오류 안내',
    content: nl2br(
      '예상하지 못한 오류가 발생하였습니다.\n서버의 일시적인 장애이거나 네트워크 문제일 수 있습니다. 잠시 후 다시 시도해 주세요.'
    )
  },
  [DicaronCommonErrorCode.LOGIN_REQUIRED]: {
    title: '서비스 오류 안내',
    content: nl2br(
      '예상하지 못한 오류가 발생하였습니다.\n서버의 일시적인 장애이거나 네트워크 문제일 수 있습니다. 잠시 후 다시 시도해 주세요.'
    )
  }
};

const ServerErrorPopup = ({errorCode, onSubmit}: ServerErrorPopupProps) => {
  const {closePopup} = usePopup();

  const onConfirm = () => {
    closePopup();
    onSubmit();
  };

  useHistoryBackAOS(() => {
    onConfirm();
  }, []);

  const {title, content} = ERROR_INFO[errorCode];
  return (
    <Popup>
      <Popup.Title>{title}</Popup.Title>
      <Popup.Content>{content}</Popup.Content>
      <Popup.GroupButton>
        <button
          type="button"
          className="btn btn_gray"
          data-tiara-action-name={TIARA_ACTION.CONFIRM_CLICK}
          onClick={onConfirm}
        >
          확인
        </button>
      </Popup.GroupButton>
    </Popup>
  );
};

export default ServerErrorPopup;
